import React, { Suspense, useRef, useState, useMemo } from 'react'
import * as THREE from 'three'
import { ShaderMaterial} from "three"
import { Canvas, useFrame} from 'react-three-fiber'
import { useSpring, animated, config } from 'react-spring/three'
import fragment from './glsl/fragment.glsl'
import vertex from './glsl/vertex.glsl'
import Steven from '../../images/jellyfish.jpg'

function Box({ url, ...props }) {

    const [hovered, setHover] = useState(false)
    const mesh = useRef()
    const texture = useMemo(() => new THREE.TextureLoader().load(Steven), [Steven])
    
    const { hoverValue } = useSpring({
        hoverValue: hovered ? 1 : 0,
        config: config.molasses
    })
    
    const material = useMemo(() => {
        const mat = new ShaderMaterial({
            uniforms: {
                uTime: { value: 0.0 },
                uTexture: { value: texture },
                hover: {
                    type: 'f',
                    value: 0.0
                }
            },
            
            side: THREE.DoubleSide,
            vertexShader: vertex,
            fragmentShader: fragment,
        })

        return mat
    }, [])

    //const clock = useMemo(() => new THREE.Clock())
    // must call clock inside the useFrame hook otherwise the animiation will restart on scroll and resize
    useFrame(({ clock }) => {
        if (material) {
            material.uniforms.uTime.value = clock.getElapsedTime();
        }
    })

    return (
        <animated.mesh
            ref={mesh}
            onPointerMove={e => setHover(true)}
            onPointerOut={e => setHover(false)}
            {...props}
            >
        >
            <animated.planeGeometry attach="geometry" args={[0.4, 0.6, 32, 32]} />
            <animated.shaderMaterial
                attach="material"
                args={[material]}
            />
        </animated.mesh>
    )
}

const More = () => (
    <>
        <Canvas  camera={{ position: [0, 0, 2], near: 0.01, far:5000, fov: 20 }}>
            <Suspense fallback={null}>
                <Box />
            </Suspense>
        </Canvas>
    </>
)

export default More



